import Referral from './components/pages/Referral';
import {
  Layout,
  ReferredPage,
} from '@packages/web-shared/components/referrals';
import {
  createBrowserRouter,
  createRoutesFromElements,
  Outlet,
  Route,
  RouterProvider,
} from 'react-router-dom';
import { ScrollToTop } from '@percihealth/react';
import {
  AskForRightsPage,
  AuthProvider,
  PrivateElement,
} from '@percihealth/react-auth';
import DescopeLogin from '@packages/web-shared/components/auth/DescopeLogin';
import DescopeSessionProvider from '@packages/web-shared/components/auth/DescopeSessionProvider';
import firebaseApp from './firebase';
import { ClinicalAppPermission } from '@packages/core-shared';
import { FirebaseProvider } from '@packages/web-shared';

export default function App() {
  const router = createBrowserRouter(
    createRoutesFromElements(
      <Route
        path="/"
        element={
          <Layout>
            <ScrollToTop />
            <Outlet />
          </Layout>
        }
      >
        <Route
          path="/"
          element={
            <PrivateElement permission={ClinicalAppPermission.CrmReferrer}>
              <Referral />
            </PrivateElement>
          }
        />
        <Route
          path="referred"
          element={
            <PrivateElement permission={ClinicalAppPermission.CrmReferrer}>
              <ReferredPage
                heading="Thank you for the referral"
                message={null}
              />
            </PrivateElement>
          }
        />
        <Route path="/login" element={<DescopeLogin />} />
        <Route path="/ask-for-rights" element={<AskForRightsPage />} />
      </Route>,
    ),
  );

  return (
    <DescopeSessionProvider firebaseApp={firebaseApp}>
      <AuthProvider firebaseApp={firebaseApp}>
        <FirebaseProvider firebaseApp={firebaseApp}>
          <RouterProvider router={router} fallbackElement={<p>Loading...</p>} />
        </FirebaseProvider>
      </AuthProvider>
    </DescopeSessionProvider>
  );
}
